import { useParams } from "@tanstack/react-router";

import { Queries } from "@/queries/Queries.ts";

export const usePatientIdFromURL = () => {
  return useParams({
    from: "/_practitioner/patients/$patientId",
    select: params => params.patientId,
  });
};

export const usePatientFromURL = () => {
  const patientId = usePatientIdFromURL();
  return Queries.practitioner.usePatient(patientId);
};
